<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-envelope"></i> Tickets</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Email:</label>
                  <div class="control">
                      <span v-if="item.user">{{item.user.email}}</span>
                      <span v-else="item.user">{{item.email}}</span>
                  </div>
                </div>
            </div>

            <div class="column is-12">
                <div class="field">
                    <label class="label">Title:</label>
                    <div class="control">
                        <span>{{item.title}}</span>
                    </div>
                </div>
            </div>

            <div class="column is-12">
                <div class="field">
                    <label class="label">Category:</label>
                    <div class="control">
                        <span>{{item.category}}</span>
                    </div>
                </div>
            </div>

            <div class="column is-12">
                <div class="field">
                    <label class="label">Content:</label>
                    <div class="control">
                        <span>{{item.content}}</span>
                    </div>
                </div>
            </div>

            <div class="column is-12" v-if="item.user && item.user.profile">
                <div class="field">
                  <label class="label">Is teacher?</label>
                  <div class="control">
                      <i class="fa fa-check has-text-success" v-if="item.user"></i>
                      <i class="fa fa-times has-text-danger" v-else></i>
                  </div>
                </div>
            </div>
            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import TicketRepo from '../../repos/TicketRepo'
import lodash from 'lodash'

export default {
  name: 'tickets-show',
  components: {},
  data() {
        return {
            repo: new TicketRepo(this.$auth),
            item: {},
        }
  },
  created(){  
    this.getUser(this.$route.params.id);
  },
  methods: {
    getUser(id){
        this.repo.show(id).then(response => {            
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/tickets/Show.vue